import React from "react";
import moment from "moment";
import { moneyize } from "../../../../../onestep-library/TextPresenters/index";
import classnames from "classnames";

export default function AvailableFundsListing({
  amount,
  description,
  kind,
  refunded_at,
  created_at,
  payment_method,
  receipt,
  paid_at,
}) {
  return (
    <tr
      className={classnames("cursor-default hoverable", {
        "text-muted": !!refunded_at,
      })}
    >
      <td>{moment(paid_at).format("MMMM, DD, YYYY")}</td>
      <td className="text-capitalize">
        {payment_method == "online" ? "Card" : payment_method}
      </td>
      <td>{description}</td>
      <td>
        {kind == "credit" ? (
          <div
            className={classnames({
              "text-success": !refunded_at,
              "text-muted": !!refunded_at,
            })}
            style={{ fontWeight: "500" }}
          >
            +{moneyize(amount)}
          </div>
        ) : (
          <div
            className={classnames({
              "text-danger": !refunded_at,
              "text-muted": !!refunded_at,
            })}
            style={{ fontWeight: "500" }}
          >
            -{moneyize(amount)}
          </div>
        )}
      </td>
      <td>{receipt?.receipt_email ? 'Sent' : 'Not Sent'}</td>
      <td>{refunded_at ? "Refunded" : ''}</td>
      <td>{receipt && <ReceiptButton receipt={receipt} />}</td>
    </tr>
  );
}

const ReceiptButton = ({ receipt }) => {
  console.warn('receipt', receipt);
  return (
    <a
      target='_blank'
      href={`/organizations/${receipt.organization_name}/receipts/${receipt.id}?tkn=${receipt.uuid}`}
      className="btn btn-primary btn-small text-white"
    >
      View Receipt
    </a>
  )
}
